<!-- 由 suu 创建于 2021-11-17 星期三 -->
<template>
  <div class="gym-calendar">
    <CalTop @top="onTop"></CalTop>
    <div class="cal-cent">
      <yearCalendar
        v-if="curTop == 1"
        @yearChange="onYearChange"
        :curType="0"
        :food="info.food"
        :getImg="false"
        :training="info.training"
        :course="info.class"
      ></yearCalendar>
      <Calendar
        v-if="curTop == 0"
        @OnClickDay="OnClickDay"
        @monthChange="onMonthChange"
        :curType="0"
        :getImg="false"
        :food="info.food"
        :training="info.training"
        :course="info.class"
      ></Calendar>
    </div>
    <CalCourse
      :courseInfo="courseInfo"
      v-if="curTop == 0 && (courseInfo.plan || courseInfo.coachname)"
    ></CalCourse>
  </div>
</template>

<script>
import CalTop from './ponents/cal-top.vue'
import CalCourse from './ponents/cal-course.vue'
import Calendar from './ponents/Calendar.vue'
import yearCalendar from './ponents/yearCalendar.vue'
export default {
  name: 'gym-calendar',

  components: { CalTop, CalCourse, Calendar, yearCalendar },

  props: {},

  data() {
    return {
      // 当前日课程信息
      courseInfo: {
        coachname: '',
        plan_id: '',
        plan: null,
        shoot_img: []
      },
      info: {
        class: {},
        food: {},
        training: []
      },
      curTop: 0,
      curYear: new Date().getFullYear()
    }
  },

  computed: {},

  watch: {},

  created() {
    // 获取传入的默认年月
    let ym = ''
    if (this.$route.query.month && this.$route.query.year) {
      ym = this.$route.query.year + '-' + this.$route.query.month
    }
    this.getInfo(0, ym)
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 点击日期
     */
    OnClickDay(obj) {
      console.log('====================================')
      console.log('objobj', obj)
      console.log('====================================')
      // 没有请求过当天训练计划数据
      if (!obj.plan_id) {
        this.$toast.loading('加载中···')
        this.$http
          .get(
            'member/Poster?a=getPlan',
            { uid: this.uid, day: obj.curDayText },
            true
          )
          .then((res) => {
            this.$toast.clear()
            if (res.data.code === 200) {
              // this.info = res.data.data;
              obj.plan = res.data.data
              this.courseInfo = obj
            } else {
              this.$$dialog.alert({ message: res.data.msg })
            }
          })
          .catch((err) => {
            this.$toast.clear()
            this.$$dialog.alert({ message: '网络错误' })
          })
      } else {
        this.$toast.loading('加载中···')
        setTimeout(() => {
          this.courseInfo = obj
          this.$toast.clear()
        }, 500)
      }
    },
    /**
     * 切换日期回参
     */
    onMonthChange(obj) {
      this.info = obj
    },
    /**
     * 切换年份
     */
    onYearChange(obj) {
      this.info = obj
    },
    /**
     * 获取信息
     */
    getInfo(flag = 0, ym = '') {
      if (!flag) this.$toast.loading('加载中···')
      this.$http
        .get('member/Poster?a=getStatistics', { uid: this.uid, ym }, true)
        .then((res) => {
          this.$toast.clear()
          if (res.data.code === 200) {
            this.info = res.data.data
          } else {
            this.$$dialog.alert({ message: res.data.msg })
          }
        })
        .catch((err) => {
          this.$toast.clear()
          this.$$dialog.alert({ message: '网络错误' })
        })
    },
    /**
     * 点击tab
     */
    onTop(i) {
      this.curTop = i
      let ym = ''
      if (i === 1) {
        ym = this.curYear
      }
      this.getInfo(0, ym)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.gym-calendar {
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  background-color: #f6f6f6;
}
</style>
